import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { camelCase, sortBy } from "lodash-es";
import { getReferenceData } from "../Services/ReferenceDataService";
import {
  API_INITIAL_STATE,
  BUILDER_TYPE_FULFILLED,
  BUILDER_TYPE_REJECTED,
  SLICE_REFERENCE_DATA,
  THUNK_GET_REFERENCE_DATA,
} from "../Constants/SliceAndThunkConstants";
import { apiSliceBuilderService } from "../Services/CommonServices";

export const fetchReferenceData = createAsyncThunk(
  `${SLICE_REFERENCE_DATA}/${THUNK_GET_REFERENCE_DATA}`,
  async () => {
    const response = await getReferenceData();
    return response;
  }
);

export const formatReferenceData = (references) => {
  if (!references) {
    return {};
  }
  const returnObj = {};
  for (const [key, value] of Object.entries(references)) {
    if (!value) {
      continue;
    }

    const modifiedOptions = value.map((opt) => {
      return {
        value: opt?.CODE,
        displayEs: opt?.DISPLAY_ES,
        displayEn: opt?.DISPLAY_EN,
        rank: opt?.RANK,
        description: opt?.DESCRIPTION,
        valueText: opt?.VALUE,
      };
    });
    returnObj[camelCase(key)] = [
      ...sortBy(modifiedOptions, (opt) => +opt.rank),
    ];
  }
  return returnObj;
};

const initialState = {
  referenceOptions: {},
  status: false,
  fetchReferenceDataResponse: API_INITIAL_STATE,
};

export const referenceDataSlice = createSlice({
  name: "referenceData",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchReferenceData.rejected, (state, action) => {
      state.status = false;
      state.fetchReferenceDataResponse = apiSliceBuilderService(
        BUILDER_TYPE_REJECTED,
        action
      );
    });
    builder.addCase(fetchReferenceData.fulfilled, (state, action) => {
      state.referenceOptions = formatReferenceData(action?.payload?.data);
      state.fetchReferenceDataResponse = apiSliceBuilderService(
        BUILDER_TYPE_FULFILLED,
        action
      );
      state.status = true;
    });
  },
});

export default referenceDataSlice.reducer;
